/**
 * Drawer Teleport
 * Mueve el custom-menu-drawer al body para escapar del contexto de apilamiento del header sticky
 */

(function() {
  function teleportDrawer() {
    const drawer = document.querySelector('custom-menu-drawer');
    
    if (drawer && drawer.parentElement.tagName !== 'BODY') {
      console.log('[Drawer Teleport] Moviendo drawer al body...');
      document.body.appendChild(drawer);
      console.log('[Drawer Teleport] Drawer movido correctamente');
    }
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teleportDrawer);
  } else {
    teleportDrawer();
  }
  
  // También ejecutar en el theme editor cuando se carga/reordena
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(teleportDrawer, 100);
    });
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(teleportDrawer, 100);
    });
  }
})();

